<template>
  <button @click="getPhoneVerify" :class="count !== 60? 'grayFont' : ''">{{ codeText }}</button>
</template>

<script>
import {Toast} from "vant";
import {mixins} from "../mixins";

export default {
  name: "verifyButton",
  mixins: [mixins],
  props: {
    phone: {
      type: String,
    },
    type: {
      type: Number,
      require: true,
    },
    code: {
      type: String,
      require: true,
    },
    token: {
      type: String,
      require: true,
    },
    //是否需要判断电话号码
    judgePhone: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      count: 60,
      codeText: "获取验证码",
      timer: null,
      flag: true, //防抖节流
      smsToken: "",
    };
  },
  methods: {
    //获取手机验证码
    getPhoneVerify() {
      let reg = /^1[3456789]\d{9}$/;
      if (this.judgePhone && !reg.test(this.phone)) {
        return Toast("手机号码不正确，请重新输入");
      }
      if (!this.code) {
        return Toast("请输入图片验证码");
      }
      if (this.flag) {
        this.flag = false; //改变状态，防止多次点击
        this.smsToken = this.createNonceStr();
        window.sessionStorage.setItem("smsToken", this.smsToken);
        let data = {
          phone: this.phone,
          type: this.type,
          smsToken: this.smsToken,
          code: this.code,
          token: this.token,
        };
        this.$post("user/sendBindPhoneSms", data).then(result => {
          if (result.status === 200) {
            if (this.type === 3) this.$emit("getStatus", result.data.status)
            if (this.type === 3 && result.data.status === 1) {
              this.flag = true;
              return Toast("该手机号已绑定微信，请更换");
            } else {
              this.onClickCode();
              return Toast("发送成功");
            }
          } else {
            //重新获取图片验证码
            this.$emit('resetImgVerifyCode');
            this.flag = true;
            Toast(result.msg);
          }
        })
      } else {
        return Toast("不能连续获取验证码");
      }
    },
    //点击获取验证码
    onClickCode() {
      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count--;
          this.codeText = `${this.count}秒后获取`;
        } else {
          this.codeText = "获取验证码";
          this.count = 60;
          this.flag = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="less">
.grayFont {
  color: #999999 !important;
}

button {
  color: #126afc;
  background: transparent;
  font-size: 15px;
  border: none;
  padding: 0;
}
</style>